import React, { useState } from "react";
import DashboardPrincipal from "./DashboardPrincipal";
import VistaART from "./VistaART";
import VistaDistribucion from "./VistaDistribucion";
import { useParticipantesData } from "./use-participantes-data";
import { Spin, Button, Space, Row } from "antd";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../store/auth/selectors';

const Page = () => {
  const [vistaActual, setVistaActual] = useState("dashboard");
  const { data, loading } = useParticipantesData();
  const appName = 'visita_participante';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const permissionPrint = permissions.priv_print === 'Y';

  const renderVista = () => {
    if (!data) return null; // Prevenir render hasta tener datos

    switch (vistaActual) {
      case "dashboard":
        return (
          <DashboardPrincipal
            data={data}
            onNavigateToART={() => setVistaActual("art")}
            onNavigateToDistribucion={() => setVistaActual("distribucion")}
          />
        );
      case "art":
        return <VistaART data={data} onBack={() => setVistaActual("dashboard")} />;
      case "distribucion":
        return <VistaDistribucion data={data} onBack={() => setVistaActual("dashboard")} />;
      default:
        return null;
    }
  };

  return (
    <div className="container">
      <div className="row mb-2 d-flex align-items-center">
        <div className="col-md-7 linea_separador mb-2 d-flex align-items-center">
          <div className="titulo_proyecto" style={{ flexBasis: "25%", flexGrow: 0 }}>
            <p>PROYECTO UTF <br /> COL 160 COL</p>
          </div>
          <div className="objeto" style={{ flexBasis: "75%", flexGrow: 0 }}>
            <p>
              Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades
              institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
            </p>
          </div>
        </div>
        <div className="col-md-5 d-flex justify-content-center align-items-center flex-column">
          <h4 className="text-center mb-3">Visitas técnicas</h4>
          <Row justify="center">
            <Space>
              <Button
                type={vistaActual === "dashboard" ? "primary" : "default"}
                onClick={() => setVistaActual("dashboard")}
              >
                Dashboard Principal
              </Button>
              <Button
                type={vistaActual === "art" ? "primary" : "default"}
                onClick={() => setVistaActual("art")}
              >
                Informe de ejecución              </Button>
              {permissionPrint && (<Button
                type={vistaActual === "distribucion" ? "primary" : "default"}
                onClick={() => setVistaActual("distribucion")}
              >
                Reporte visitas
              </Button>)}
            </Space>
          </Row>
        </div>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", paddingTop: 100 }}>
          <Spin size="large" tip="Cargando participantes..." />
        </div>
      ) : (
        renderVista()
      )}
    </div>
  );
};

export default Page;
